<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30.038" viewBox="0 0 30 30.038">
        <path id="Icon_open-reload" data-name="Icon open-reload"
            d="M15.019,0A15.019,15.019,0,1,0,25.682,25.682l-2.7-2.7a11.272,11.272,0,1,1-8-19.224,10.923,10.923,0,0,1,7.847,3.417l-4.093,4.093H30V0L25.532,4.468A14.935,14.935,0,0,0,14.981,0Z"
            fill="#f58634" />
    </svg>
</template>